import React, { memo, useCallback, useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { CheckInRequirements } from "@/dataLayer/CheckInRequirements";
import { setTrackUserActivityCheckIn } from "@/dataLayer/CheckinData";
import { groupBookingValidationPassenger } from "@/dataLayer/groupBooking";
import JourneyCardV2 from "components/SearchWidgetPanel/Check-in/JourneyCardV2/JourneyCardV2";
import { IconV2 } from "components/V2/atoms/IconV2/IconV2";
import { TextFieldV2 } from "components/V2/atoms/TextFieldV2/TextFieldV2";
import { BookingDetailContext } from "context/BookingDetailsContext";
import { screenContext } from "context/ScreenContext";
import { findPrimaryContact } from "helper/contact";
// eslint-disable-next-line import/order
import { useSelector, useDispatch } from "react-redux";
import { displayToastNotification } from "@/utils/helperFunctions/displayToastNotification";
import { bookingIniatedFrom, setBookingIniatedFrom } from "@/store/slices/booking";
import { setSelectedJourneys, setCurrentBookingInStateContext } from "@/store/slices/checkIn";
import { setPassengersKeys } from "@/store/slices/groupBooking";
import { eventName } from "../../../../../constants/events/eventName";
import { LIFT_STATUS, NOTIFICATION_MESSAGE_TYPE, PASSENGER_TYPE, STATUS } from "../../../../../constants/variables";
import { BookingDataContext } from "../../../../../context/BookingDataContext";
import { CommonDataContext } from "../../../../../context/CommonDataContext";
import { extractResource } from "../../../../../helper/extractResource";
import { resetLocalStorage } from "../../../../../services/resetLocalStorage";
import { trackUserActivity } from "../../../../../services/trackUserActivity";
import { deepCopy } from "../../../../../utils/jsonUtils";
import ResCallenders from "../../../../SearchWidgetPanel/Check-in/ResCallenders";
import { displayCheckinMessage } from "../../../../SearchWidgetPanel/Check-in/helperFunctions/displayCheckinMessage";
import { ButtonV2 } from "../../../atoms/ButtonV2/ButtonV2";
import { ModalV2 } from "../../../atoms/ModalV2/ModalV2";
import { saveBookingInRedux } from "@/services/manageBooking";
export interface CheckInPopupProps {
  isOpen: boolean;
  showLastName?: boolean;
  resourceData: {};
  handleClose: () => void;
}

type userName = {
  firstName: string;
  lastName: string;
};

function CheckInPopupGroupBookingV2({
  isOpen,
  showLastName = false,
  resourceData,
  handleClose
}: CheckInPopupProps) {
  const router = useRouter();
  const dispatch = useDispatch();

  const bookingInState = useSelector((state: any) => state.persistedReducers.booking);
  const { checkInData, journeysInfo, userInputs, groupSelectedJourneysCard, isPrimaryContact } = useSelector(
    (state: any) => state.persistedReducers.groupBooking
  );

  const { passenger, setPassenger } = useContext<any>(BookingDataContext);
  const { setCurrentBookingInStateData } = useContext(BookingDetailContext);
  const { currentDevice } = useContext(screenContext);
  const { passengerTypes, setSelectedSpecialFare, setSelectedCurrency, resources } = useContext<any>(CommonDataContext);

  const [currentBookingInState, setCurrentBookingInState] = useState<any>([]);
  const [userName, setUserName] = useState<userName>({
    firstName: "",
    lastName: ""
  });
  const [checkInRequirementState, setCheckInRequirementState] = useState<any>([]);
  const [passengerSegments, setPassengerSegments] = useState<any>(currentBookingInState?.journeys);
  const [paxDetailsByAgeGroups, setPaxDetailsByAgeGroups] = useState<{}>({});
  const [journeysInfoInState, setJourneysInfoInState] = useState(journeysInfo);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isUserValidate, setIsUserValidate] = useState<boolean>(false);
  const [errorTexts, setErrorTexts] = useState<boolean>(false);
  const [isPaxAlreadyCheckIn, setAlreadyCheckedIn] = useState<boolean>(false);
  const [isShowLastName, setShowLastName] = useState<boolean>(showLastName);

  const specialFares = passengerTypes?.filter(
    (item: { passengerTypeCode: string }) =>
      item?.passengerTypeCode !== PASSENGER_TYPE.ADULT &&
      item?.passengerTypeCode !== PASSENGER_TYPE.CHILD &&
      item?.passengerTypeCode !== PASSENGER_TYPE.SENIOR_CITIZEN
  );

  const tempPaxDetailsByAgeGroups: any = {};

  const toastNotification = (toasterType: string) => {
    displayToastNotification(NOTIFICATION_MESSAGE_TYPE.ERROR, toasterType);
  };

  const handleModalClose = () => {
    handleClose();
    setIsUserValidate(false);
  };

  const handleChange = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    setUserName((preValues) => ({ ...preValues, [name]: value }));
  };

  const handleCheckIn = () => {
    const currentBookingInStateContext = { data: currentBookingInState };
    if (groupSelectedJourneysCard?.length >= 1) {
      dispatch(setCurrentBookingInStateContext(currentBookingInStateContext));
      trackUserActivity({
        eventName: eventName.MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED,
        details: {
          currentBookingInState,
          bookingInState
        }
      });
      setIsLoading(false);
      router.push("/check-in-summary");
    } else {
      trackUserActivity({
        eventName: eventName.MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED_ERROR,
        details: {
          currentBookingInState,
          bookingInState,
          error: "checkInSubmitFailed"
        }
      });
      setIsLoading(false);
    }
  };

  const handleCheckInRequirements = async (currentBookingInStates: any, passengerKeys:any) => {
    const { journeys } = currentBookingInStates;

    // Early return if there are no journeys
    if (!journeys || journeys.length === 0) {
      console.warn("No journeys found.");
      return;
    }

    try {
      // Use Promise.all to handle multiple asynchronous calls
      const checkInPromises = journeys.map(async (journey: any) => {
        try {
          const response: any = await CheckInRequirements(journey.journeyKey);
          return { ...response, journeyDetails: journey }; // Attach journey details to the response
        } catch (checkInError) {
          console.error(`Error fetching check-in requirements for journeyKey ${journey.journeyKey}:`, checkInError);
          return { journeyDetails: journey };
        }
      });

      const checkInRequirements: any = await Promise.all(checkInPromises);

      let filterJourney = checkInRequirements?.map((journey: any) => {
          // Check if the current journey's key matches any selected journey's key
          if (groupSelectedJourneysCard?.some((selectedJourneyCard: any) => journey.journeyDetails.journeyKey === selectedJourneyCard.journeyKey)) {
            journey.ischecked = true;
          }
          return journey;
        }).filter((journey: any) => journey.ischecked);
          
      let filterJourneyByPaxCheckIn = checkInRequirements?.map((journey: any) => {
        const updatedSegments = journey.journeyDetails?.segments?.map((segment: any) => {
          // Determine if all passengers in this segment are checked in or boarded
          const allPaxCheckedInOrBoarded = segment?.passengerSegment?.every((paxSegment: any) => 
              paxSegment.liftStatus === LIFT_STATUS.CHECKEDIN || paxSegment.liftStatus === LIFT_STATUS.BOARDED
          );
  
          return {
              ...segment, // Retain existing properties
              isCheckedInOrBoarded: allPaxCheckedInOrBoarded, // Add the check result
          };
        }) || [];

        // Determine if all segments have all passengers checked in or boarded
        const allSegmentsCheckedInOrBoarded = updatedSegments.every((segment: any) => segment.isCheckedInOrBoarded);

        return {
            ...journey, // Spread the existing properties of the journey
            journeyDetails: {
                ...journey.journeyDetails, // Spread the existing properties of journeyDetails
                segments: updatedSegments, // Replace segments with the filtered segments
            },
            isAlreadyCheckIn: allSegmentsCheckedInOrBoarded // Add the new property
        };
      });

      // Check if any journey has all segments with passengers checked in or boarded
      const hasAllJourneysCheckedIn = filterJourneyByPaxCheckIn?.some((journey: any) => journey.isAlreadyCheckIn);

      if (hasAllJourneysCheckedIn) {
        setAlreadyCheckedIn(true); // Set state once instead of within the loop
      }

      const filterJourneysInfo = journeysInfo?.map((journey: any) => {
        const journeyCheckedIn = filterJourneyByPaxCheckIn?.find((filterJourney: any) => 
            filterJourney?.journeyDetails?.journeyKey === journey?.journeyKey
        );
    
        const isAlreadyCheckedIn = journeyCheckedIn?.isAlreadyCheckIn || false;
        // Determine whether to display the card
        const displayCard = (!isAlreadyCheckedIn || journey?.restrictions !== null);
    
        return { ...journey, isAlreadyCheckedIn, displayCard};

      }).filter((journey: any) => journey.displayCard);

      if (passengerKeys.length > 0 && filterJourneyByPaxCheckIn.length > 0){
        setJourneysInfoInState([...filterJourneysInfo]); 
        dispatch(setSelectedJourneys(filterJourney));
        setCheckInRequirementState(checkInRequirements);
        setIsUserValidate(true);
        if (filterJourneyByPaxCheckIn?.some((journey: any) => !journey?.isAlreadyCheckIn && journey?.ischecked)) {
          handleCheckIn();
        }else{
          setIsLoading(false);
        }
      }  
    } catch (error) {
      console.error("Error in handleCheckInRequirements:", error);
    }
  };

  const handleResponse = async (currentBookingState: any, userDetails: any, passnegerKeys:any) => {

    if (currentBookingState.restriction.allowCheckIn === false) {
      toastNotification(extractResource(resourceData, "checkInNotAllowed"));
      return;
    }

    dispatch(
      setBookingIniatedFrom({
        bookingIniatedFrom: bookingIniatedFrom.CHECKIN_BOOKING
      })
    );

    setTrackUserActivityCheckIn(currentBookingState, userDetails);
    setCurrentBookingInStateData({ data: { data: currentBookingState } }); //set into BookingDetailContext

    setSelectedCurrency(currentBookingState?.currencyCode);
    saveBookingInRedux({ currentBooking: currentBookingState, refreshBookingData: true, dispatch }); //setting in a Redux 

    setCurrentBookingInState(currentBookingState); //useState
    setPassengerSegments(currentBookingState.journeys);

    const checkInstatus = checkInData?.info?.status;
    if (checkInstatus === STATUS.CONFIRMED) {
      handleCheckInRequirements(currentBookingState, passnegerKeys);
    } else {
      toastNotification(extractResource(resourceData, "noBookingFound"));
    }
  };

  const handleValidateUser = async () => {
    const { pnrDetails, lastName } = userInputs;

    const param = {
      firstName: userName.firstName,
      lastName: isShowLastName ? userName?.lastName : lastName,
      recordLocator: pnrDetails
    };

    try {
      const currentBookingState = await groupBookingValidationPassenger(param);

      // Check for validation failure
      if (currentBookingState?.status === false) {
        setErrorTexts(true);
        setIsLoading(false);
        return false;
      }
      
      if(currentBookingState?.passengers){
        const passnegerKeys = currentBookingState?.passengers?.map((passenger: any) => passenger.passengerKey);
        setErrorTexts(false);
        sessionStorage.setItem("passnegerKeys", JSON.stringify(passnegerKeys));
        dispatch(setPassengersKeys(passnegerKeys));
        
        handleResponse(currentBookingState, param, passnegerKeys);
      } else{
        toastNotification(extractResource(resources, "enterValidatePaxName"));
      }
    } catch (error) {
      console.error("Error during booking validation:", error);
    }
  };

  const handleCheckInSubmit = async () => {
    resetLocalStorage("CHECKIN_START");
    setIsLoading(true);
    await handleValidateUser();
  };

  const formatPaxObjForTravelersDetail = (
    passengerObject: { info: any; name: { first: any; last: any } },
    isInfant = false
  ) => {
    let passengerDetails = passengerObject?.info;

    if (isInfant === true) {
      passengerDetails = passengerObject;
    }

    return {
      first: passengerObject?.name?.first,
      last: passengerObject?.name?.last,
      gender: passengerDetails?.gender,
      dateOfBirth: passengerDetails?.dateOfBirth
    };
  };

  const updatePassengerDetailsByAge = (passengerData: any, matchedPaxType: string) => {
    if (typeof tempPaxDetailsByAgeGroups[matchedPaxType] === "undefined") {
      tempPaxDetailsByAgeGroups[matchedPaxType] = [];
    }
    tempPaxDetailsByAgeGroups[matchedPaxType].push(
      formatPaxObjForTravelersDetail(passengerData, matchedPaxType === PASSENGER_TYPE.INFANT)
    );
  };

  const updatePassengersDetail = useCallback(async () => {
    let selectedSpecialFareType: any;
    let passengersHaveSeniors = false;
    let checkForInfants = false;
    const passengerObjectCopy: any = deepCopy(passenger);
    currentBookingInState?.passengers?.forEach((passengerObj, index) => {
      if (index === 0 && passengerObjectCopy) {
        passengerObjectCopy.adult = 0;
        passengerObjectCopy.total = 0;
        passengerObjectCopy.child = 0;
        passengerObjectCopy.seniorcitizen = 0;
        passengerObjectCopy.infant = 0;
      }

      const passengerType = passengerObj?.value?.passengerTypeCode;
      const isSpecialFare = [
        PASSENGER_TYPE.ADULT,
        PASSENGER_TYPE.ARMED_FORCE,
        PASSENGER_TYPE.MEDICAL,
        PASSENGER_TYPE.STUDENT
      ].includes(passengerType);
      const isInfant =
        passengerObj?.value?.infant &&
        typeof passengerObj?.value?.infant === "object" &&
        Object.keys(passengerObj?.value?.infant).length > 0;

      if (
        isSpecialFare ||
        passengerType === PASSENGER_TYPE.SENIOR_CITIZEN ||
        passengerType === PASSENGER_TYPE.CHILD ||
        passengerType === PASSENGER_TYPE.MINOR
      ) {
        const matchedPaxType: any =
          (passengerType === PASSENGER_TYPE.SENIOR_CITIZEN && PASSENGER_TYPE.SENIOR_CITIZEN) ||
          (isSpecialFare ? PASSENGER_TYPE.ADULT : PASSENGER_TYPE.CHILD);
        updatePassengerDetailsByAge(passengerObj?.value, matchedPaxType);
        passengerObjectCopy[matchedPaxType] += 1;
        passengerObjectCopy.total += 1;
        checkForInfants = isSpecialFare || passengerType === PASSENGER_TYPE.SENIOR_CITIZEN;
        passengersHaveSeniors = passengersHaveSeniors || passengerType === PASSENGER_TYPE.SENIOR_CITIZEN;
        selectedSpecialFareType = passengersHaveSeniors ? null : passengerType;
      }

      if (checkForInfants && isInfant) {
        updatePassengerDetailsByAge(passengerObj?.value?.infant, PASSENGER_TYPE.INFANT);
        passengerObjectCopy.infant += 1;
        checkForInfants = false;
      }
    });
    setPassenger(passengerObjectCopy);
    if (selectedSpecialFareType) {
      const specialFareObject = await specialFares?.find(
        (specialFare: any) => specialFare?.passengerTypeCode === selectedSpecialFareType
      );
      if (specialFareObject && Object.keys(specialFareObject).length > 0) {
        setSelectedSpecialFare(specialFareObject);
      }
    }

    const contactDetails = findPrimaryContact(currentBookingInState.contacts);
    tempPaxDetailsByAgeGroups.PRIMARY_CONTACT_DETAILS = [
      { mobile: contactDetails?.phoneNumbers?.[0]?.number, email: contactDetails?.emailAddress }
    ];
    if (Object.keys(paxDetailsByAgeGroups).length === 0) {
      setPaxDetailsByAgeGroups(tempPaxDetailsByAgeGroups);
    }
  }, [currentBookingInState.passengers]);

  useEffect(() => {
    if((userInputs?.email && userInputs?.email.includes("@") || isPrimaryContact)){
      setShowLastName(true);
    } else {
      setShowLastName(false);
    }
}, [userInputs, userInputs?.email, showLastName, isPrimaryContact])

  useEffect(() => {
    let isComponentMounted = true;
    if (isComponentMounted) {
      updatePassengersDetail();
    }
    dispatch(setSelectedJourneys([]));

    return () => {
      isComponentMounted = false;
    };
  }, []);

  const modalHeaderMweb = () => {
    return (
      <div id="modalHeader" className="flex gap-3 py-1.5">
        {currentDevice === "mobile" && (
          <button onClick={handleModalClose} type="button">
            <IconV2
              blok={{
                component: "icon",
                icon: "chevron-left",
                height: 20,
                width: 20,
                alt: "clear Icon"
              }}
            />
          </button>
        )}
        {extractResource(resourceData, "myBookingPopupOptionsCheckIn")}
      </div>
    );
  };

  return (
    <ModalV2
      size="sm"
      modalWidth={`${currentDevice === "mobile" ? "auto" :  `${ isShowLastName ? "550px" : "466px" }`}`}
      isOpen={isOpen}
      onClose={handleModalClose}
      modalTitle={modalHeaderMweb()}
      scrollable={true}
      showBorderRadius={currentDevice === "mobile" ? false : true}
      setModalBottom={true}
      modalHeight={currentDevice === "mobile" ? "100vh" : "calc(100% - 64px)"}
      maxHeight={currentDevice === "mobile" ? "100vh" : "calc(100% - 64px)"}
      hideCloseIcon={currentDevice === "mobile" ? true : false}
      additionalClassHeader={currentDevice === "mobile" ? "shadow-2xl shadow-[#0000001A] drop-shadow-xl" : ""}
      classNamechildren="flex flex-col"
    >
      <div>
        <div className="bg-background-highlight-primary px-1" id="checkInGroupBookingPopup">
          <div id="journeyHeading" className="font-semibold text-lg text-typography-primary p-4 pb-0">
            {displayCheckinMessage(journeysInfo, resourceData)}
            {journeysInfo && (
              <span id="journeyStations">
                &nbsp;{journeysInfo?.[0]?.designator?.origin}-{journeysInfo?.[0]?.designator.destination}
              </span>
            )}
          </div>
          <p id="pnrDetails" className="font-medium text-sm text-typography-primary p-4 pt-2">
            {extractResource(resourceData, "pnr")}&nbsp;
            {checkInData?.recordLocator}
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-between h-full px-5 pt-2 pb-4 sm:pb-0">
        <div>
            {journeysInfoInState.filter((journeyCard) => journeyCard?.restrictions === null)?.length >= 1 &&
              <>
                <p id="upcomingFlightsTitle" className="py-2">
                  {extractResource(resourceData, "checkInGroupBookingMsg")}
                </p>
                <div className="flex gap-3 py-2">
                  <TextFieldV2
                    label="First Name"
                    name="firstName"
                    value={userName?.firstName}
                    onChange={handleChange}
                    autoComplete="off"
                    additionalWrapperClassNames="w-full"
                    additionalInputClassNames={`capitalize ${errorTexts ? '!border-[#D31313]' : ''}`}
                    viewHeight="h-14 pt-1"
                    additionalLabelClassNames="pt-4"
                    variant="underline"
                  />
                  {isShowLastName && <TextFieldV2
                    label="Last Name"
                    name="lastName"
                    value={userName.lastName}
                    onChange={handleChange}
                    autoComplete="off"
                    additionalWrapperClassNames="w-full"
                    additionalInputClassNames={`capitalize ${errorTexts ? '!border-[#D31313]' : ''}`}
                    viewHeight="h-14 pt-1"
                    additionalLabelClassNames="pt-4"
                    variant="underline"
                  />}
                </div>
                <div>
                  {errorTexts && (
                    <div className="flex text-typography-danger break-normal hyphens-manual text-[12px] w-full">
                      <IconV2
                        blok={{
                          component: "icon",
                          icon: "red-alert-info",
                          height: 12,
                          width: 12,
                          alt: "Red alert info"
                        }}
                      />
                      <span className="ml-1">
                        {extractResource(resources, isShowLastName ? "enterFirstAndLastNameMsg" : "enterFirstNameMsg")}
                      </span>
                    </div>
                  )}
                </div>
              </>
            }
            <>
              <p id="upcomingFlightsTitle" className="py-2 text-[18px] leading-6 font-semibold">
                {extractResource(resourceData, "yourUpcomingFlights")}
              </p>
              {journeysInfoInState.length > 0 && (
                <JourneyCardV2
                  journeysInfo={journeysInfoInState}
                />
              )}
              {isPaxAlreadyCheckIn && (
                <ResCallenders
                  isChangeBooking={false}
                  passengerSegments={passengerSegments}
                  currentBookingInState={{ data: { data: currentBookingInState } }}
                  CheckInRequirement={checkInRequirementState}
                  resourceData={resourceData}
                />
              )}
            </>
          </div>
          {currentDevice !== "mobile" && (
            <div className="items-center py-5 flex justify-center">
              <ButtonV2
                id="checkInPopUpButton"
                blok={{
                  variant: "primary",
                  text: extractResource(resourceData, "checkIn"),
                  isFullWidthOnMobile: false
                }}
                isLoading={isLoading}
                onClick={handleCheckInSubmit}
                isDisabled={!groupSelectedJourneysCard?.length || !(journeysInfoInState.filter((journeyCard) => journeyCard?.restrictions === null)?.length >= 1)}
              />
            </div>
          )}
      </div>
      <div className={`${isUserValidate && checkInRequirementState.length === 0 && "py-3 px-4"}`}>
        {isUserValidate && checkInRequirementState && checkInRequirementState.length === 0 && (
          <div className="flex justify-center mb-5">
            {extractResource(
              resourceData,
              "onlineCheckInOpens48HoursPriorToDepartureAFacilitationFeeOf200IsApplicableForAirportCheckInWithAssistance"
            )}
          </div>
        )}

        {currentDevice === "mobile" && (
          <div className="p-4">
            <ButtonV2
              id="checkInPopUpButton"
              additionalButtonClassName="h-12 w-full"
              blok={{ variant: "primary", text: extractResource(resourceData, "checkIn"), isFullWidthOnMobile: false }}
              isLoading={isLoading}
              onClick={handleCheckInSubmit}
              isDisabled={!groupSelectedJourneysCard?.length || !(journeysInfoInState.filter((journeyCard) => journeyCard?.restrictions === null)?.length >= 1)}
            />
          </div>
        )}
      </div>
    </ModalV2>
  );
}

export default memo(CheckInPopupGroupBookingV2);